// @ts-nocheck
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import translate from "@insite/client-framework/Translate";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { StepperContextProvider, useStepperContext } from "@store/Framework/Components/StepperContext";
import { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import expandProps from "@toolkit/Framework/Common/Utilities/expandProps";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";
import { spacingStyles } from "@toolkit/Themes/common/mixins/spacing";
import React, { FC, HTMLAttributes, PropsWithChildren } from "react";
import { css } from "styled-components";

export interface FormStepperPresentationProps extends ExpandStyles<FormStepperStyles> {}

export interface FormStepperProps extends FormStepperPresentationProps, HTMLAttributes<HTMLFormElement> {}

export interface FormStepperStyles {
    actionsWrapper?: InjectableCss;
    submitButton?: ButtonPresentationProps;
    wrapper?: InjectableCss;
}

export const formStepperStyles: FormStepperStyles = {
    actionsWrapper: {
        css: css`
            ${spacingStyles(pxToRem(40), null)}
        `,
    },
    submitButton: {
        variant: "primary",
        mergeCss: true,
        css: css`
            min-width: min(${pxToRem(220)}, 100%);
        `,
    },
};

const FormStepper: FC<PropsWithChildren<FormStepperProps>> = ({
    children,
    extendedStyles,
    overridedStyles,
    ...htmlAttributes
}) => {
    const styles = expandProps(formStepperStyles, extendedStyles, overridedStyles);

    return (
        <StyledWrapper as="form" noValidate {...styles.wrapper} {...htmlAttributes}>
            <StepperContextProvider>
                {children}
                <FormStepperActions styles={styles} />
            </StepperContextProvider>
        </StyledWrapper>
    );
};

export interface FormStepperActionsProps {
    styles: FormStepperStyles;
}

const FormStepperActions: FC<FormStepperActionsProps> = ({ styles }) => {
    const { allStepsCompleted } = useStepperContext();

    return (
        <StyledWrapper
            {...styles.actionsWrapper}
            // The submit button must remain rendered (and disabled) to prevent native form submission (e.g: pressing "enter" in a textfield)
            style={!allStepsCompleted ? { display: "none" } : undefined}
            aria-hidden={!allStepsCompleted}
        >
            <Button {...styles.submitButton} disabled={!allStepsCompleted} type="submit">
                {translate("Submit")}
            </Button>
        </StyledWrapper>
    );
};

export default FormStepper;
